<template>
  <vs-wrapper>
    <removable-row
      :show-row="showParentLocationField"
      data-test="parent-field-rem-row"
      @remove="$emit('remove-parent-location-field')"
    >
      <new-location-picker
        data-test="parent-loc-field"
        label="Parent location"
        :value="props.parentId ?? undefined"
        @input="$emit('parent-location-input', $event)"
      />
    </removable-row>

    <removable-row
      :show-row="showDescriptionField"
      data-test="desc-field-rem-row"
      @remove="$emit('remove-description-field')"
    >
      <vs-text-input
        label="Description"
        data-test="description-field"
        :value="props.description"
        multiline
        @input="$emit('description-input', $event)"
      />
    </removable-row>

    <removable-row
      :show-row="showStatusField"
      data-test="status-field-rem-row"
      @remove="$emit('remove-status-field')"
    >
      <auto-complete
        :items="statuses"
        :value="props.colorId"
        data-test="status-field"
        label="Status"
        @input="$emit('color-input', $event)"
      />
    </removable-row>

    <removable-row
      :show-row="showTagsField"
      data-test="tags-field-rem-row"
      @remove="$emit('remove-tags-field')"
    >
      <vs-heading>Tags</vs-heading>
      <TagsEditor :initial-tags="[]" @update="handleTagUpdate" @error="handleTagsError" />
      <vs-text v-if="showTagsErrorMessage" type="warning">
        {{ tagsErrorMessage }}
      </vs-text>
    </removable-row>
  </vs-wrapper>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { sortBy } from 'lodash'
import { useGetLocationStatusesQuery } from '@/api/locations'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import AutoComplete from '@/components/common/AutoComplete.vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import NewLocationPicker from '@/components/locations/NewLocationPicker.vue'
import RemovableRow from '@/components/common/RemovableRow.vue'
import NewTag from '@/models/new_tag'
import TagsEditor from '@/components/common/tags/TagsEditor.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsText from '@/components/vision/VsText.vue'

const props = defineProps<{
  showParentLocationField: boolean
  showDescriptionField: boolean
  showStatusField: boolean
  showTagsField: boolean
  parentId?: number | null
  description?: string | null
  colorId?: number | null
}>()
const { data: locationStatuses } = useGetLocationStatusesQuery()
const statuses = computed(() => {
  return sortBy(
    locationStatuses.value?.map((ls) => ({
      text: ls.name,
      value: ls.id,
      color: ls.hexCode,
    })),
    'text',
  )
})

const showTagsErrorMessage = ref(false)
const tagsErrorMessage = ref<string | null>(null)
const emit = defineEmits(['tags-input'])
const handleTagUpdate = (e: NewTag[]) => {
  emit('tags-input', e)
  showTagsErrorMessage.value = false
}
const handleTagsError = (err: string | null) => {
  tagsErrorMessage.value = err
  showTagsErrorMessage.value = true
  setTimeout(() => {
    showTagsErrorMessage.value = false
  }, 5000)
}
</script>
